<div mat-dialog-content class="wrapper">
	<div class="title">
		<h2>יש לבחור פריט</h2>
	</div>
	<div class="lines-wrapper">
		<div class="line" *ngFor="let line of lines">
			<div class="line-content">
				<div class="line-content-left">
					<div class="line-content-left-title">
						{{ line.likutRow.ProductName }}
					</div>
					<div class="line-content-left-subtitle">
						{{ line.likutRow.ProductId }}
					</div>
				</div>
				<div class="line-content-right">
					<button mat-raised-button color="primary" (click)="onLineClick(line)">בחר</button>
				</div>
			</div>
		</div>
	</div>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="onCancelClick()" cdkFocusInitial>סגור</button>
</div>
